export default {
  wallet: {
    main: "Main",
    spot: "Spot",
    portfolio: "Portfolio (soon)"
  },
  operations: {
    deposit: "Deposit",
    withdrawal: "Withdrawal",
    exchange: "Exchange",
    transfer: "Transfer"
  },
  history: {
    openOrders: "Orders (Spot)",
    profitLossLimit: "Stop/Limit (Spot)",
    transactions: "Transactions (Spot)",
    otc: "Fast & OTC Trade"
  }
};
